import { gql } from '@apollo/client';

export * from './secureUploadCancel.mutation.generated';

export const SECURE_UPLOAD_CANCEL = gql`
  mutation secureUploadCancel($softwareEscrowId: ID!, $uploadId: String!) {
    secureUploadCancel(input: { softwareEscrowId: $softwareEscrowId, uploadId: $uploadId }) {
      success
      errors
    }
  }
`;
